export default "__VITE_ASSET__Clb43SLU__"